module.exports = __webpack_public_path__ + "/images/testimonial-1.6d7a304.png";